import { render, staticRenderFns } from "./TextAnnotationArea.vue?vue&type=template&id=6d64134c&scoped=true&"
import script from "./TextAnnotationArea.vue?vue&type=script&lang=js&"
export * from "./TextAnnotationArea.vue?vue&type=script&lang=js&"
import style0 from "./TextAnnotationArea.vue?vue&type=style&index=0&id=6d64134c&prod&lang=scss&scoped=true&"
import style1 from "./TextAnnotationArea.vue?vue&type=style&index=1&id=6d64134c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64134c",
  null
  
)

export default component.exports